import { Stack, useTheme } from '@mui/material';
import CompanyLogo from 'components/CompanyLogo';
import {
  ExportTrackButton,
  LastSaveInfo,
  SaveProjectButton,
} from './components';
import { Container, StyledAppBar, StyledLogoContainer } from './styled';

const Header = () => {
  const theme = useTheme();

  return (
    <StyledAppBar
      position="static"
      color="inherit"
      data-testid="appbar-remixer"
    >
      <Container direction="row">
        <StyledLogoContainer>
          <CompanyLogo />
        </StyledLogoContainer>
        <Stack
          direction="row"
          spacing={theme.spacing(2)}
          ml="auto"
          alignItems="center"
        >
          <LastSaveInfo />
          <SaveProjectButton />
          <ExportTrackButton />
        </Stack>
      </Container>
    </StyledAppBar>
  );
};

export default Header;
